import { render, staticRenderFns } from "./myMvmStatusPanel.vue?vue&type=template&id=0c36f2a4&scoped=true&"
import script from "./myMvmStatusPanel.vue?vue&type=script&lang=js&"
export * from "./myMvmStatusPanel.vue?vue&type=script&lang=js&"
import style0 from "./myMvmStatusPanel.vue?vue&type=style&index=0&id=0c36f2a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c36f2a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/NestJsProjects/ivm_web_ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c36f2a4')) {
      api.createRecord('0c36f2a4', component.options)
    } else {
      api.reload('0c36f2a4', component.options)
    }
    module.hot.accept("./myMvmStatusPanel.vue?vue&type=template&id=0c36f2a4&scoped=true&", function () {
      api.rerender('0c36f2a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/myMvmStatusPanel.vue"
export default component.exports